import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyCWBhPLz-EtyXWT0zWR2hhDL4W3F-x4FCc",
  authDomain: "insurance-28653.firebaseapp.com",
  projectId: "insurance-28653",
  storageBucket: "insurance-28653.firebasestorage.app",
  messagingSenderId: "142684047589",
  appId: "1:142684047589:web:af3e16644fc9df518cec0c",
  measurementId: "G-LF9PK1ZSWR"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics (only in browser)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Initialize Firestore
const db = getFirestore(app)

// Initialize Auth
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

export { app, analytics, db, auth, googleProvider }
